import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './components/app-main/app.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { MainContentComponent } from './components/layouts/main-content/main-content.component';
import { NavBarComponent } from './components/layouts/nav-bar/nav-bar.component';
import { SideBarComponent } from './components/layouts/side-bar/side-bar.component';
import { LoginComponent } from 'src/app/modules/users/components/login/login.component';
import { WelcomeComponent } from 'src/app/modules/users/components/welcome/welcome.component';
import { LoaderModule } from '../loader/loader.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ForgetPasswordComponent } from 'src/app/modules/users/components/forget-password/forget-password.component';
import { ModuleSelectionComponent } from 'src/app/modules/users/components/module-selection/module-selection.component';
import { LoginCallbackComponent } from 'src/app/modules/users/components/login-callback/login-callback.component';
import { ActiveSessionsComponent } from 'src/app/modules/users/components/active-sessions/active-sessions.component';
import { SecuritySettingsComponent } from 'src/app/modules/users/components/security-settings/security-settings.component';
import { SharedComponentModule } from '../shared-components/shared-components.module';
import { RtlDirective } from 'src/app/sharedFeatures/directives/rtl.directive';
import { ToggleSideMenuDirective } from '../directives/toggleSideMenu';
import { ErrorInterceptor } from 'src/app/sharedFeatures/services/http-error-interceptor';
import { ReplaceSvgDirective } from 'src/app/sharedFeatures/directives/mnue-replace-svg';
import { ApiInterceptor } from 'src/app/sharedFeatures/services/api-interceptor.service';
import { TokenRefreshInterceptor } from 'src/app/sharedFeatures/services/token-refresh-interceptor.service';
import { SystemCodeSideBarComponent } from './components/layouts/system-code-side-bar/system-code-side-bar.component';
import { TitleStrategy } from '@angular/router';
import { TranslatedTitleStrategy } from 'src/app/sharedFeatures/services/translated-title.strategy';

// import { ChartsModule } from 'ng2-charts';
//import { StatsCardComponent } from 'src/app/modules/dashboard/components/stats-card/stats-card.component';
//import { PopularCoursesComponent } from 'src/app/modules/dashboard/components/popular-courses/popular-courses.component';
//import { CourseStatusComponent } from 'src/app/modules/dashboard/components/course-status/course-status.component';
//import { BestMentorsComponent } from 'src/app/modules/dashboard/components/best-mentors/best-mentors.component';
//import { UpcomingLessonsComponent } from 'src/app/modules/dashboard/components/upcoming-lessons/upcoming-lessons.component';
//import { MonthlyProgressComponent } from 'src/app/modules/dashboard/components/monthly-progress/monthly-progress.component';
//import { NoticeBoardComponent } from 'src/app/modules/dashboard/components/notice-board/notice-board.component';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    MainContentComponent,
    NavBarComponent,
    SideBarComponent,
    SystemCodeSideBarComponent,
    LoginComponent,
    WelcomeComponent,
    ForgetPasswordComponent,
    ModuleSelectionComponent,
    LoginCallbackComponent,
    ActiveSessionsComponent,
    SecuritySettingsComponent,
    RtlDirective,
    ToggleSideMenuDirective,
    ReplaceSvgDirective,

    /*StatsCardComponent,
    PopularCoursesComponent,
    CourseStatusComponent,
    BestMentorsComponent,
    UpcomingLessonsComponent,
    MonthlyProgressComponent,
    NoticeBoardComponent*/
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    LoaderModule,
    SharedComponentModule,
    ReactiveFormsModule,
    FormsModule,
    // ChartsModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right', // Position at the top-right
      closeButton: true,
      easeTime: 500,
      enableHtml: true,
      progressBar: true,
      progressAnimation: 'increasing',
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenRefreshInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: TitleStrategy, useClass: TranslatedTitleStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
